module.exports = __webpack_public_path__ + "ff49bf70ef519ab59eded28f023cb786.jpg";